// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"e587241c","232":"85f13a8f","237":"1c79ad6d","483":"5667da6d","526":"8bab0cd4","872":"7129da09"}[chunkId] + ".chunk.js";
};